module.exports = __webpack_public_path__ + "img/x-icon.b16ed8c0.svg";